<template>
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
            trackCode='reverseSupplementList-1'
          >
            <template slot="batch-search-btn">
              <el-button
                type="primary"
                :size="formSize"
                :loading="loading"
                @click="handleBatchSearch()"
              >
                批量查询
              </el-button>
            </template>
          </jr-search2>
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList">
            <template #sourceList>
              <page-source-select
                title="归属业务"
                :sources="queryForm.sourceList"
                @select-change="sourceChange"
              />
            </template>
            <template #selectList>
              <page-select-cascader
                title="补款方式"
                :selectOptions="selectWayOptions"
                :selectList="queryForm.selectList"
                :cascaderStyle="{minWidth: '300px'}"
                @change="cascaderChange"
                :cascaderProps="cascaderProps"
                :hasAll="false"
              />
            </template>
          </page-select-groups>
          <div class="fan-search-col fan-search-right">
            <!-- 表格数据配置 -->
            <jr-columns-config
              :columnsKey="columnsKey"
              :tableColumn="tableColumn"
              :selectTableColumn="selectTableColumn"
              @confirm="handleConfirm"
            />
            <div style="margin-left: 10px" v-if="$has('FWS-NXDD-BKJL-DC')">
              <page-export-button
                buttonText="导出"
                exportServe="fin_payment_orderSuppleReport"
                :total="total"
                :isLimit="true"
                :exportParams="exportParams"
                trackCode='reverseSupplementList-2'
              />
            </div>
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="selectTableColumn"
          ref="tableListRef"
        >
          <template v-slot:certificate="{row}">
            <span v-if="!row.certificate">-</span>
            <jr-preview-image
              v-else
              :row-id="row.refundOrderNo"
              :image-list="$stringToArray(row.certificate)"
            />
          </template>
          <template v-slot:operate="{row}">
            <btns-operate :current="row" @success="getList" :show="['WAIT'].includes(row.suppleStatus)" />
          </template>
        </jr-table>
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 详情 -->
    <detail
      :visible.sync="isDetailShow"
      :suppleOrderNo.sync="suppleOrderNo"
      :applyNo="applyNo"
      @after-done="getList"
    />
    <!-- 批量搜索 -->
    <batch-search
      :visible.sync="isBatchSearchShow"
      :type-list="batchSearchTypeList"
      :loading="loading"
      @confirm="handleBatchSearchConfirm"
      trackCode='approvalSubAccountList-2'
    />
  </div>
</template>

<script>
import { getSupplementBopList } from '@/api/supplement';
import detail from './components/detail';
import { setStatusColor } from '@/filters/index';
import btnsOperate from './components/btns-operate';
import { tableColumnsKeys } from '@/utils/constant';
import * as _ from 'lodash';

const queryFormDefault = {
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  contentList: '', // 搜索值
  searchType: '3',
  timeType: '1',
  suppleStatus: '',
  suppleWay: '',
  suppleType: '',
  transType: '2', // 业务类型:1-自营,2-服务商
  sourceList: [],
  suppleChannels: [],
  selectList: [],
};

export default {
  name: 'ReverseSupplementList',
  components: { btnsOperate, detail },
  data() {
    const list = [
      { value: '3', label: '业务订单号' },
      { value: '1', label: '补款单编号' },
      { value: '2', label: '补款申请编号' },
      { value: '4', label: '客户编号' },
      { value: '5', label: '客户名称' },
      { value: '6', label: '操作人' },
    ];
    return {
      loading: false,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建日期', value: '1' },
            { label: '操作日期', value: '2' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'contentList',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: list,
        },
      ],
      columnsKey: tableColumnsKeys.reverseSupplementList,
      tableColumn: [
        {
          prop: 'suppleOrderNo',
          label: '补款单编号',
          minWidth: '1',
          disabled: true,
          permission: 'FWS-NXDD-BKJL-XQ',
          trackCode: 'reverseSupplementList-3',
          click: (row) => {
            this.handleDetail(row);
          },
        },
        { prop: 'orderNumber', label: '业务订单号', minWidth: '1' },
        { prop: 'suppleApplyNo', label: '补款申请单号', minWidth: '1' },
        { prop: 'businessNo', label: '客户编号', minWidth: '1' },
        { prop: 'businessName', label: '客户名称', minWidth: '1' },
        { prop: 'suppleTypeDesc', label: '补款类型', minWidth: '1' },
        { prop: 'suppleAmount', label: '补款金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'suppleWayDesc', label: '补款方式', minWidth: '1' },
        { prop: 'suppleChannelDesc', label: '补款渠道', minWidth: '1' },
        { prop: 'certificate', label: '补款凭证', minWidth: '1', slotName: 'certificate' },
        { prop: 'createUser', label: '申请人', minWidth: '1' },
        { prop: 'createTime', label: '创建时间', minWidth: '1', filterName: 'formatTime', disabled: true },
        {
          prop: 'suppleStatus',
          label: '状态',
          status: 'suppleStatus',
          statusDesc: 'suppleStatusDesc',
          disabled: true,
          statusColor: (val) => setStatusColor(val, 'cancelStatus'),
        },
        { prop: 'modifyUser', label: '操作人', minWidth: '1' },
        { prop: 'thirdFinishTime', label: '补款到账时间', filterName: 'formatTime(yyyy-MM-dd)' },
        { prop: 'suppleReason', label: '补款原因', showOverflowTooltip: true },
        { prop: 'operate', label: '操作', width: '165', slotName: 'operate', disabled: true },
      ],
      selectTableColumn: [],
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      isDetailShow: false, // 详情弹窗
      suppleOrderNo: '',
      applyNo: '',
      selectList: [
        {
          title: '补款类型',
          prop: 'suppleType',
          dictionaryPath: '/finance/finance-payment/SuppleTypeEnum',
        },
        {
          title: '状态',
          prop: 'suppleStatus',
          dictionaryPath: '/finance/finance-payment/SuppleStatusEnum',
        },
        {
          slotName: 'selectList',
          dictionaryPath: '/finance/finance-payment/SuppleWayEnum',
        },
        {
          slotName: 'sourceList',
        },
      ],
      cascaderProps: {
        multiple: true,
        checkStrictly: true,
        value: 'value',
        label: 'codeName',
        children: 'childs',
      },
      /** ------批量搜索开始---- */
      // 批量搜索搜索条件集合
      batchSearchTypeList: [
        { value: '3', label: '业务订单号' },
        { value: '1', label: '补款单编号' },
        { value: '2', label: '补款申请编号' },
      ],
      isBatchSearchShow: false, // 批量搜索
      batchResults: {}, // 批量操作返回结果
      /** ------批量搜索结束---- */
    };
  },
  computed: {
    exportParams() {
      const params = {
        ...this.queryForm,
        contentList: this.queryForm.contentList ? this.queryForm.contentList.split(',') : [],
      };
      delete params.page;
      delete params.limit;
      return params;
    },
    selectWayOptions() {
      const { dictData = {} } = this.$store.state.dictionary;
      const arr = _.cloneDeep(dictData['/finance/finance-payment/SuppleWayEnum']) || [];
      arr.unshift({
        value: 'all',
        codeName: '全部',
      });
      return arr;
    },
  },
  created() {
    this.init();
  },
  methods: {
    // 批量查询提交
    handleBatchSearchConfirm(form) {
      this.batchResults = form;
      const param = { ...queryFormDefault };
      param.searchType = form.searchType || '';
      param.contentList = (form.list || []).join(',');
      this.queryForm = { ...param };
      this.getList();
    },
    // 批量查询弹窗
    handleBatchSearch() {
      this.isBatchSearchShow = true;
    },
    cascaderChange(params) {
      const { selectList, parentSelect, childrenSelect } = params;
      this.queryForm.selectList = selectList;
      this.queryForm.suppleChannels = childrenSelect;
      this.queryForm.suppleWay = parentSelect;
      this.refreshList();
    },
    sourceChange(list) {
      this.queryForm.sourceList = [...list];
      this.refreshList();
    },
    // 配置确认
    handleConfirm(values) {
      this.selectTableColumn = values;
      this.$nextTick(() => {
        this.$refs.tableListRef.doLayout();
      });
    },
    async init() {
      this.$store.dispatch('dictionary/getDictionary', { type: 'SUPPLE_WAY' });
      try {
        const list = await this.$store.dispatch('dictionary/getUserTemplate', {
          pageKeys: [this.columnsKey],
          columnsKey: this.columnsKey,
          tableColumn: this.tableColumn,
        });
        this.selectTableColumn = list;
      } catch (error) {
        this.selectTableColumn = this.tableColumn;
      }
      this.getList();
    },
    // 列表查询
    async getList() {
      try {
        this.loading = true;
        const params = {
          ...this.queryForm,
          contentList: this.queryForm.contentList ? this.queryForm.contentList.split(',') : [],
        };
        delete params.selectList;
        const res = await getSupplementBopList(params);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.isBatchSearchShow = false; // 批量搜索弹窗关闭
      } catch (error) {
        this.list = [];
        this.total = 0;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = {
        ...this.queryForm,
        ...params,
        page: 1,
      };
      this.getList();
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
    // 详情
    handleDetail(row) {
      this.suppleOrderNo = row?.suppleOrderNo || '';
      this.applyNo = row.suppleApplyNo;
      this.isDetailShow = true;
    },
  },
};
</script>
